<script lang="tsx" setup>
import type { AudioBlob } from 'vocal-recorder'
import { useAudioPlayback } from 'ui'
import { useForm } from '../state'

const props = defineProps<{
  result: AudioBlob
}>()

const { reset } = useForm()

const url = useObjectUrl(props.result)
const audioRef = new Audio(url.value)

const { peaksRef, ...audio } = useAudioPlayback(url.value!, { audioRef })
const timeLeft = computed(() => Math.round(audio.state.duration - audio.state.time))
</script>

<template>
  <h2 class="text-40px font-semibold leading-none" :class="audio.state.isPlaying && 'text-$color-primary'">
    {{ timeLeft }}s
  </h2>

  <div v-once ref="peaksRef" class="h-40px max-w-240px w-full">
    <AudioPlayerPeaks :peaks="result.peaks" />
  </div>

  <div class="flex-center gap-6">
    <IconButton class="icon-button" variant="secondary" size="lg" icon="i-solar-restart-bold" @click="reset" />
    <IconButton
      class="icon-button" variant="primary" size="lg"
      :icon="audio.state.isPlaying ? 'i-solar-pause-bold' : 'i-solar-play-bold'" @click="audio.togglePlay()"
    />
  </div>
</template>
